module.exports = __webpack_public_path__ + "assets/img/3.93e3eaae.png";